import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useTheme as useThemeV4 } from '@material-ui/core/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

const muiCache = createCache({ key: 'mui-datepicker', prepend: true });

const createDatePickerTheme = v4Theme => {
  return createTheme({
    palette: {
      primary: {
        main: v4Theme.palette.primary.main,
        light: v4Theme.palette.primary.light,
        dark: v4Theme.palette.primary.dark,
        contrastText: v4Theme.palette.primary.contrastText
      },
      text: {
        primary: v4Theme.palette.text.primary,
        secondary: v4Theme.palette.text.secondary
      },
      background: {
        default: v4Theme.palette.background?.default,
        paper: v4Theme.palette.background?.paper
      }
    },
    typography: {
      fontFamily: v4Theme.typography.fontFamily,
      fontSize: v4Theme.typography.fontSize,
      h6: v4Theme.typography.h6
    },
    components: {
      ...(v4Theme.overrides?.MuiPickersToolbar && {
        MuiPickersToolbar: {
          styleOverrides: v4Theme.overrides.MuiPickersToolbar
        }
      }),
      ...(v4Theme.overrides?.MuiPickersCalendarHeader && {
        MuiPickersCalendarHeader: {
          styleOverrides: v4Theme.overrides.MuiPickersCalendarHeader
        }
      }),
      MuiPickersDay: {
        styleOverrides: {
          root: {
            fontFamily: v4Theme.typography.fontFamily,
            fontSize: v4Theme.typography.fontSize,
            '&.Mui-selected': {
              backgroundColor: v4Theme.palette.primary.main,
              color: v4Theme.palette.primary.contrastText,
              '&:hover': {
                backgroundColor: v4Theme.palette.primary.dark
              }
            },
            '&:hover': {
              backgroundColor: v4Theme.palette.primary.light
            }
          }
        }
      }
    }
  });
};

export const DatePickerThemeWrapper = ({ children }) => {
  const v4Theme = useThemeV4();
  const datePickerTheme = useMemo(() => createDatePickerTheme(v4Theme), [
    v4Theme
  ]);

  return (
    <CacheProvider value={muiCache}>
      <ThemeProvider theme={datePickerTheme}>{children}</ThemeProvider>
    </CacheProvider>
  );
};

DatePickerThemeWrapper.propTypes = {
  children: PropTypes.node
};

export default DatePickerThemeWrapper;
